import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { SubmissionContext } from '../utils/SubmissionContextProvider';
import CircleSpinner from './CircleSpinner';
import Button from './Button';
import { sendCustomEvent } from '../helpers/gtm';

const uploadImages = async (files, updateFileCount) => {
  const uploadedIds = [];

  for (let i = 0; i < files.length; i++) {
    const data = new FormData();
    data.append('action', 'upload_submission_image');
    data.append('image', files[i].file);

    const res = await fetch(window.localizationInfo?.ajaxUrl, {
      method: 'POST',
      body: data
    });
    if (!res.ok) {
      throw new Error('Image upload failed');
    }
    const response = await res.json();
    uploadedIds.push(response.attachment_id);
    updateFileCount(i + 1);
  }

  return uploadedIds;
};

const uploadSubmission = async (data, imageIds) => {
  const submissionData = {
    action: 'upload_submission',
    title: data.title,
    description: data.description,
    whySolutionNeeded: data.whySolutionNeeded,
    howSolutionSustainable: data.howSolutionSustainable,
    whichRegion: data.whichRegion,
    whyPromoteYourRegion: data.whyPromoteYourRegion,
    usePrizeMoney: data.usePrizeMoney,
    media: imageIds,
    firstname: data.firstname,
    lastname: data.lastname,
    aboutYourself: data.aboutYourself,
    dateOfBirth: data.dateOfBirth,
    email: data.email,
    regionOrPlace: data.regionOrPlace,
    acceptTerms: data.acceptTerms
  };

  const formData = new FormData();
  for (const key in submissionData) {
    formData.append(key, submissionData[key]);
  }
  const res = await fetch(window.localizationInfo?.ajaxUrl, {
    method: 'POST',
    body: formData
  });
  if (!res.ok) {
    throw new Error('Submission failed');
  }
  return true;
};

const SendSubmission = ({ submitting, onError }) => {
  const data = useContext(SubmissionContext);
  const [complete, setComplete] = useState(false);
  const [imageUploadCount, setImageUploadCount] = useState(0);
  const [label, setLabel] = useState('Vorbereiten');

  useEffect(() => {
    setLabel(`Hochladen (${Math.ceil((imageUploadCount / data.media?.length) * 100)} %)`);
  }, [imageUploadCount, setLabel]);

  const handleError = message => {
    // Reset state
    onError(message);
    setComplete(false);
    setImageUploadCount(0);
    setLabel('Vorbereiten');
  };

  useEffect(() => {
    if (submitting) {
      // Step 1: Upload images
      setLabel('Vorbereiten');
      uploadImages(data.media || [], setImageUploadCount)
        .then(imageIds => {
          setTimeout(() => {
            setLabel('Abschließen');
            uploadSubmission(data, imageIds)
              .then(() => {
                sendCustomEvent('idea_submitted');
                setTimeout(() => {
                  setLabel(data.firstname ? `Vielen Dank, ${data.firstname}!` : 'Vielen Dank!');
                  setComplete(true);
                }, 1000);
              })
              .catch(() =>
                handleError(
                  'Beim Einreichen Deiner Idee ist ein Fehler aufgetreten. Bitte prüfe Deine Angaben und versuche es erneut.'
                )
              );
          }, 1000);
        })
        .catch(() =>
          handleError(
            'Beim Hochladen der Bilder ist ein Problem aufgetreten. Bitte wähle ggf. weniger und kleinere Bilder aus und probiere es erneut.'
          )
        );
    }
  }, [submitting]);

  return (
    <div className={`c-send-submission ${submitting ? 'c-send-submission--active' : ''}`}>
      <CircleSpinner size={150} complete={complete} />
      <h2 className='c-send-submission__label'>{label}</h2>
      {!complete ? null : (
        <>
          <p>Wir wünschen Dir viel Erfolg und melden uns bei Dir, sobald es etwas Neues gibt.</p>
          <Button
            onClick={() => {
              window.location = '/';
            }}
            label='Weiter zur Startseite'
          />
        </>
      )}
    </div>
  );
};

SendSubmission.propTypes = {
  submitting: PropTypes.bool,
  onError: PropTypes.func
};

export default SendSubmission;
